export const GET_UTILIZATION = 'entities/GET_UTILIZATION'
